import type { WidgetColumn } from '../types';

const getWidgetColumnKey = (column: WidgetColumn): string | undefined =>
  column.key ?? column.componentId;

export const getOrderedSearchableColumns = (
  columns: WidgetColumn[] = [],
  searchableColumns: string[] = [],
) => {
  const ordered = columns
    .map(col => {
      const key = getWidgetColumnKey(col);
      return key ? { ...col, key } : null;
    })
    .filter((col): col is WidgetColumn & { key: string } =>
      Boolean(col?.isActive && col.key && searchableColumns.includes(col.key)),
    )
    .sort((a, b) => (a.index ?? a.order ?? 0) - (b.index ?? b.order ?? 0));

  if (ordered.length > 0) {
    return ordered;
  }

  return searchableColumns.map(key => ({ key }));
};
